// extracted by mini-css-extract-plugin
export default {"wrapper":"ActiveFilter_wrapper__5oDw3"};